import { assetsIcons } from "assets";
import { notification } from "antd";
import { NotificationType, NotificationPlacement } from "constants/common.constants";
import { ReactNode, useEffect } from "react";

const useNotification = () => {
  const [api, contextHolder] = notification.useNotification();

  // useEffect(() => {
  //   const handleCloseNotification = () => {
  //     api.destroy();
  //   };
  //   window.addEventListener("click", handleCloseNotification);

  //   return () => window.removeEventListener("click", handleCloseNotification);
  // }, []);

  const openNotificationWithIcon = ({
    type = "success",
    message = "Success!",
    description = "Successfully",
    btn = "",
    key,
    duration = 5,
    icon = type === "success" ? (
      <img src={assetsIcons.checkIcon} alt="Success" />
    ) : (
      <img src={assetsIcons.errorIconFill} alt="Error" />
    ),
    closeIcon = <img src={assetsIcons.closeIcon} alt="" />,
    placement = 'topRight'
  }: {
    type?: NotificationType;
    message?: string;
    description?: ReactNode;
    duration?: number;
    icon?: ReactNode;
    key?: string;
    btn?: ReactNode;
    closeIcon?: ReactNode;
    placement?: NotificationPlacement;
  }) => {
    api[type]({
      icon,
      closeIcon,
      message,
      duration,
      btn,
      key,
      description,
      placement,
    });
  };

  return { contextHolder, openNotificationWithIcon, destroy: api.destroy };
};

export default useNotification;
